(function () {
  var body = document.body;
  var locked = false;
  var scrollPosition = 0;
  var originalStyles = {};

  function lockPage() {
    if (locked || !window.matchMedia("(max-width: 959px)").matches) return;

    scrollPosition = window.scrollY || document.documentElement.scrollTop || 0;
    originalStyles = {
      position: body.style.position,
      top: body.style.top,
      right: body.style.right,
      left: body.style.left,
      width: body.style.width
    };

    body.style.position = "fixed";
    body.style.top = "-" + scrollPosition + "px";
    body.style.right = "0";
    body.style.left = "0";
    body.style.width = "100%";
    locked = true;
  }

  function unlockPage() {
    if (!locked) return;

    body.style.position = originalStyles.position;
    body.style.top = originalStyles.top;
    body.style.right = originalStyles.right;
    body.style.left = originalStyles.left;
    body.style.width = originalStyles.width;
    locked = false;
    window.scrollTo(0, scrollPosition);
  }

  function syncLockState() {
    if (body.getAttribute("mobile-menu-open") === "true") {
      lockPage();
    } else {
      unlockPage();
    }
  }

  new MutationObserver(syncLockState).observe(body, {
    attributes: true,
    attributeFilter: ["mobile-menu-open"]
  });

  syncLockState();
})();
